import { newsletter } from './newsletter'
import { createInstagramFeed } from './instagram'

function moveAddFooterElements() {
    // $('#footer .social-icon-list').wrapAll('<div class="social-icons"></div>')

    $('#signature').wrapAll('<div class="signature-wrapper"></div>')
    // .after(`<div class="authorized-seller">${_t('footer.authorizedSeller')}</div>`)

    // $('.site-name > a').clone().prependTo('#footer .footer-rows')

    // Add Able logo
    //$('.footer-bottom .signature-wrapper').append(` <a href="https://able.cz" class="able-logo"></a> `)

    $('.copyright').html('© 2026 PRO Industrial • Alle Rechte vorbehalten • ABAMAL wird hergestellt von <a href="https://www.alphaczech.com" target="_blank">ALPHA CZECH s.r.o.</a>')
}

function copyFooterToLocalStorage() {
    const footer = $('#footer')
    if (footer.length) {
        const footerHTML = footer.prop('outerHTML')
        localStorage.setItem('FOOTER', footerHTML)
    }
}

function addFooterToCart() {
    if ($('.ordering-process').length) {
        const footer = localStorage.getItem('FOOTER')
        if (footer) {
            $('.overall-wrapper').append(footer)
        }
    }
}

export function initFooter() {
    newsletter()
    createInstagramFeed()
    moveAddFooterElements()
    copyFooterToLocalStorage()
    addFooterToCart()
}
